var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, IconButton, TextField, Typography, styled } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid-premium';
import { t } from 'i18next';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { deleteAllAttachmentUrl, getDownloadPreJobCardDocumentAttachmentUrl } from '../../api/url';
import { AudioButtonIcon, GallaryIconNewIcon, MoreClickIconSVG } from '../../assets/customIcons';
import { DeleteButtonNewIcon } from '../../assets/images';
import { APISchema, ESABoxParent, ESystemName, Module, isModuleConfig } from '../../constants';
import { downloadAttachment, setDocDataUpdated, setIsTaskDetailsDataUpdated, showLoader } from '../../redux/commonSlice';
import { getListAPI, setState } from '../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { systemColor } from '../../theme/systemColor';
import { dataURLtoFile, getCustomerVoiceSectionAttributes, sortImagesByTimeStamp } from '../../utils/utils';
import { MuiImagePopUp } from '../atoms/imageDialogBox';
import { MuiStack } from '../atoms/stackComponent';
import AudioCapturePopUpComponent from '../molecules/audioCapturePopUpComoponent';
import { AudioPlayer } from '../molecules/audioComponent';
import ImageCaptureAndFileupload from './captureImageAndFileUpload/imageCaptureAndFileupload';
import TranslateToJobMessage from './translateToJob/translateToJobMessage';
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "24px",
        width: "24px"
    };
});
export var ImageAudioComponent = function (props) {
    var _savedAudio$audioBlob, _listOfCustomerVoice$3, _customerComplaintDat2, _customerComplaintDat3, _getCustomerVoiceSect, _getCustomerVoiceSect2, _getCustomerVoiceSect3, _listOfCustomerVoice$4, _listOfCustomerVoice$5;
    var onDataReceived = props.onDataReceived, MaxLength = props.MaxLength, isDisabled = props.isDisabled, _a = props.isRecordAudio, isRecordAudio = _a === void 0 ? true : _a, ComplaintInputPlaceHolder = props.ComplaintInputPlaceHolder, _b = props.clearDataOnSave, clearDataOnSave = _b === void 0 ? true : _b, comments = props.comments, savedPhotos = props.savedPhotos, savedAudio = props.savedAudio, createAndEditFlow = props.createAndEditFlow, isFromTaskDetails = props.isFromTaskDetails, isDataUpdated = props.isDataUpdated, _c = props.isFromFinalInspection, isFromFinalInspection = _c === void 0 ? false : _c, jobItemClick = props.jobItemClick, listOfCustomerVoice = props.listOfCustomerVoice, vehicleList = props.vehicleList, handleSaveClickTranslateToJob = props.handleSaveClickTranslateToJob, apiRequestParam = props.apiRequestParam, apiRequestPayload = props.apiRequestPayload, parentModuleDocumentId = props.parentModuleDocumentId, IsFromParentAPt = props.IsFromParentAPt, jobItemClickViewJobs = props.jobItemClickViewJobs;
    var _d = useAppSelector(function (state) { return state.crud; }), preDocumentFetch = _d.preDocumentFetch, customerComplaintDataImageAndAudio = _d.customerComplaintDataImageAndAudio, getModuleHeaderCount = _d.getModuleHeaderCount;
    var customerVoiceSectionDetails = useSelector(function (state) { return state.common; }).customerVoiceSectionDetails;
    var dispatch = useAppDispatch();
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    var _f = useState(0), audioDuration = _f[0], setAudioDuration = _f[1];
    var _g = useState([]), complaintsPhotographList = _g[0], setcomplaintsPhotographList = _g[1];
    var _h = useState(false), starRecording = _h[0], setStarRecording = _h[1];
    var _j = useState((_savedAudio$audioBlob = savedAudio === null || savedAudio === void 0 ? void 0 : savedAudio.audioBlobUrl) !== null && _savedAudio$audioBlob !== void 0 ? _savedAudio$audioBlob : ""), audioUrl = _j[0], setAudioUrl = _j[1];
    var _k = useState(null), stream = _k[0], setStream = _k[1];
    var mediaRecorder = useRef(null);
    var audio = new Audio(audioUrl !== null && audioUrl !== void 0 ? audioUrl : '');
    var _l = useState(false), isPlaying = _l[0], setIsPlaying = _l[1];
    var _m = useState([]), audioChunks = _m[0], setAudioChunks = _m[1];
    var _o = useState('user'), facingMode = _o[0], setFacingMode = _o[1];
    var _p = useState(false), singleImgSelected = _p[0], setSingleImageSelected = _p[1];
    var _q = useState(false), clearPopUpImages = _q[0], setClearPopUpImages = _q[1];
    var _r = useState(false), isDrawerOpen = _r[0], setISDrawerOpen = _r[1];
    var _s = useState(""), imageURL = _s[0], setImageURL = _s[1];
    var fileInputRef = useRef(null);
    var _t = useState(true), disableSaveButton = _t[0], setDisableSaveButton = _t[1];
    var _u = useState(false), isTranslateToJobClicked = _u[0], setisTranslateToJobChecked = _u[1];
    var _v = useState(false), audioCaptureClick = _v[0], setAudioCaptureClick = _v[1];
    var _w = useState([]), audioAttachement = _w[0], setAudioAttachment = _w[1];
    var _x = useState(false), saCommentClicked = _x[0], setSaCommentClicked = _x[1];
    useEffect(function () {
        var _savedAudio$audioBlob2;
        setcomplaintsPhotographList(savedPhotos !== null && savedPhotos !== void 0 ? savedPhotos : []);
        setAudioUrl((_savedAudio$audioBlob2 = savedAudio === null || savedAudio === void 0 ? void 0 : savedAudio.audioBlobUrl) !== null && _savedAudio$audioBlob2 !== void 0 ? _savedAudio$audioBlob2 : "");
    }, [comments, savedPhotos, savedAudio]);
    useEffect(function () {
        var _listOfCustomerVoice$;
        if (Module == isModuleConfig.Bajaj && listOfCustomerVoice && ((_listOfCustomerVoice$ = listOfCustomerVoice[0]) === null || _listOfCustomerVoice$ === void 0 || (_listOfCustomerVoice$ = _listOfCustomerVoice$.ImageAttachment) === null || _listOfCustomerVoice$ === void 0 ? void 0 : _listOfCustomerVoice$.length) > 0) {
            getDownloadImage(listOfCustomerVoice);
        }
        else {
            if (Module == isModuleConfig.Bajaj && listOfCustomerVoice) {
                var _listOfCustomerVoice$2;
                dispatch(setState({
                    key: "customerComplaintDataImageAndAudio",
                    value: _objectSpread(_objectSpread({}, customerComplaintDataImageAndAudio), {}, {
                        discription: (_listOfCustomerVoice$2 = listOfCustomerVoice[0]) === null || _listOfCustomerVoice$2 === void 0 ? void 0 : _listOfCustomerVoice$2.CustomerComplaint
                    })
                }));
            }
        }
    }, [listOfCustomerVoice && ((_listOfCustomerVoice$3 = listOfCustomerVoice[0]) === null || _listOfCustomerVoice$3 === void 0 ? void 0 : _listOfCustomerVoice$3.CustomerComplaint)]);
    useEffect(function () {
        var _customerComplaintDat;
        dispatch(setState({
            key: "customerComplaintInitialvaluesLength",
            value: customerComplaintDataImageAndAudio === null || customerComplaintDataImageAndAudio === void 0 || (_customerComplaintDat = customerComplaintDataImageAndAudio.discription) === null || _customerComplaintDat === void 0 ? void 0 : _customerComplaintDat.length
        }));
    }, [customerComplaintDataImageAndAudio === null || customerComplaintDataImageAndAudio === void 0 ? void 0 : customerComplaintDataImageAndAudio.discription]);
    useEffect(function () {
        var interval;
        if (isPlaying) {
            var startTime_1 = Date.now();
            interval = setInterval(function () {
                setAudioDuration(Math.floor((Date.now() - startTime_1) / 1000));
            }, 1000);
        }
        return function () {
            clearInterval(interval);
        };
    }, [isPlaying]);
    var getDownloadImage = function (listOfCustomerVoice) { return __awaiter(void 0, void 0, void 0, function () {
        var imageAttachementURLs_1, audioAttachementURLs_1, savedAudio_1, imageAttachmentsUrlWithMediaType1, downloadPromise, audioAttachmentsUrlWithMediaType2, downloadPromise1, error_1, sortedImages, finalImages, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 7]);
                    imageAttachementURLs_1 = [];
                    audioAttachementURLs_1 = [];
                    savedAudio_1 = [];
                    imageAttachmentsUrlWithMediaType1 = listOfCustomerVoice[0].ImageAttachment.filter(function (item) { return item.MediaType === 1; });
                    downloadPromise = imageAttachmentsUrlWithMediaType1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 5];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, getDownloadPreJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    imageAttachementURLs_1.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                        base64: base64
                                    }));
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_3 = _a.sent();
                                    console.error(error_3);
                                    return [3 /*break*/, 4];
                                case 4: return [3 /*break*/, 6];
                                case 5:
                                    imageAttachementURLs_1.push(_objectSpread({}, imageItem));
                                    _a.label = 6;
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); });
                    audioAttachmentsUrlWithMediaType2 = listOfCustomerVoice[0].ImageAttachment.filter(function (item) { return item.MediaType === 2; });
                    downloadPromise1 = audioAttachmentsUrlWithMediaType2.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_4;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 5];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, getDownloadPreJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    console.log("base64", base64);
                                    audioAttachementURLs_1.push(base64);
                                    savedAudio_1.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                        isAlreadyUploaded: true,
                                        base64: base64
                                    }));
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_4 = _a.sent();
                                    console.error(error_4);
                                    return [3 /*break*/, 4];
                                case 4: return [3 /*break*/, 6];
                                case 5:
                                    savedAudio_1.push(_objectSpread({}, imageItem));
                                    _a.label = 6;
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); });
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.all(downloadPromise)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(downloadPromise1)];
                case 3:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5:
                    if (audioAttachementURLs_1.length > 0) {
                        setAudioUrl(audioAttachementURLs_1);
                    }
                    sortedImages = sortImagesByTimeStamp(imageAttachementURLs_1);
                    finalImages = sortedImages.map(function (item) {
                        var convertedFile = dataURLtoFile(item.base64, "image-".concat(new Date().toISOString(), ".png"));
                        return _objectSpread(_objectSpread({}, item), {}, {
                            blobUrl: item.base64,
                            file: convertedFile,
                            isAlreadyUploaded: true
                        });
                    });
                    setAudioAttachment(audioAttachmentsUrlWithMediaType2);
                    dispatch(setState({
                        key: "customerComplaintDataImageAndAudio",
                        value: _objectSpread(_objectSpread({}, customerComplaintDataImageAndAudio), {}, {
                            images: finalImages,
                            discription: listOfCustomerVoice[0].CustomerComplaint,
                            audio: savedAudio_1[0],
                            customerVoiceId: listOfCustomerVoice[0].CustomerVoiceId
                        })
                    }));
                    setcomplaintsPhotographList(finalImages);
                    return [3 /*break*/, 7];
                case 6:
                    error_2 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.error("CustomerComplaintView :: getDownloadImageError :: ", error_2);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var onOpenClick = function () {
        setOpen(true);
    };
    var handleCancleClick = function (value) {
        setOpen(value);
    };
    var handleConfirmClick = function (data) {
        setcomplaintsPhotographList(data);
        dispatch(setState({
            key: "customerComplaintDataImageAndAudio",
            value: _objectSpread(_objectSpread({}, customerComplaintDataImageAndAudio), {}, {
                images: data
            })
        }));
        dispatch(setDocDataUpdated(true));
        dispatch(setIsTaskDetailsDataUpdated(true));
        if (isDataUpdated) {
            isDataUpdated(true);
        }
        setDisableSaveButton(false);
    };
    var handleTextField = function (event) {
        var complaintDescription = event.target.value.trimStart();
        dispatch(setState({
            key: "customerComplaintDataImageAndAudio",
            value: _objectSpread(_objectSpread({}, customerComplaintDataImageAndAudio), {}, {
                discription: complaintDescription
            })
        }));
        dispatch(setState({
            key: "customerLength",
            value: complaintDescription.length
        }));
        dispatch(setDocDataUpdated(true));
        dispatch(setIsTaskDetailsDataUpdated(true));
        if (isDataUpdated) {
            isDataUpdated(true);
        }
        setDisableSaveButton(false);
    };
    var onClickRemovePhotoIcon = function (photoIndex, AttachmentId) { return __awaiter(void 0, void 0, void 0, function () {
        var _DeleteAttchementResp, _DeleteAttchementResp2, request, DeleteAttchementResponse, updatedComplaintList, updatedComplaintList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDisableSaveButton(false);
                    setSingleImageSelected(false);
                    if (!AttachmentId) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    request = {
                        SystemName: ESystemName.CustomerVoice,
                        ParentId: listOfCustomerVoice[0].CustomerVoiceId,
                        AttachmentId: AttachmentId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: deleteAllAttachmentUrl,
                            request: request
                        }))];
                case 2:
                    DeleteAttchementResponse = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if ((DeleteAttchementResponse === null || DeleteAttchementResponse === void 0 || (_DeleteAttchementResp = DeleteAttchementResponse.payload) === null || _DeleteAttchementResp === void 0 || (_DeleteAttchementResp = _DeleteAttchementResp.value) === null || _DeleteAttchementResp === void 0 ? void 0 : _DeleteAttchementResp.statusCode) == 200 || DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp2 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp2 !== void 0 && (_DeleteAttchementResp2 = _DeleteAttchementResp2.value) !== null && _DeleteAttchementResp2 !== void 0 && _DeleteAttchementResp2.success) {
                        updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
                        updatedComplaintList.splice(photoIndex, 1);
                        setcomplaintsPhotographList(updatedComplaintList);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                    }
                    return [3 /*break*/, 5];
                case 4:
                    updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
                    updatedComplaintList.splice(photoIndex, 1);
                    setcomplaintsPhotographList(updatedComplaintList);
                    dispatch(setState({
                        key: "customerComplaintDataImageAndAudio",
                        value: _objectSpread(_objectSpread({}, customerComplaintDataImageAndAudio), {}, {
                            images: updatedComplaintList
                        })
                    }));
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleEmptyImage = function (item) {
        setDisableSaveButton(false);
        setcomplaintsPhotographList([]);
    };
    var onDeleteRecording = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _audioAttachement$, _audioAttachement$2, _DeleteAttchementResp3, _DeleteAttchementResp4, request, DeleteAttchementResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((_audioAttachement$ = audioAttachement[0]) !== null && _audioAttachement$ !== void 0 && _audioAttachement$.AttachmentId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    request = {
                        SystemName: ESystemName.CustomerVoice,
                        ParentId: listOfCustomerVoice[0].CustomerVoiceId,
                        AttachmentId: (_audioAttachement$2 = audioAttachement[0]) === null || _audioAttachement$2 === void 0 ? void 0 : _audioAttachement$2.AttachmentId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: deleteAllAttachmentUrl,
                            request: request
                        }))];
                case 2:
                    DeleteAttchementResponse = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if ((DeleteAttchementResponse === null || DeleteAttchementResponse === void 0 || (_DeleteAttchementResp3 = DeleteAttchementResponse.payload) === null || _DeleteAttchementResp3 === void 0 || (_DeleteAttchementResp3 = _DeleteAttchementResp3.value) === null || _DeleteAttchementResp3 === void 0 ? void 0 : _DeleteAttchementResp3.statusCode) == 200 || DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp4 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp4 !== void 0 && (_DeleteAttchementResp4 = _DeleteAttchementResp4.value) !== null && _DeleteAttchementResp4 !== void 0 && _DeleteAttchementResp4.success) {
                        setAudioUrl(null);
                        setDisableSaveButton(false);
                        setAudioDuration(0);
                        dispatch(setIsTaskDetailsDataUpdated(true));
                        dispatch(setState({
                            key: "customerComplaintDataImageAndAudio",
                            value: _objectSpread(_objectSpread({}, customerComplaintDataImageAndAudio), {}, {
                                audio: null
                            })
                        }));
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setAudioUrl(null);
                    setDisableSaveButton(false);
                    setAudioDuration(0);
                    dispatch(setIsTaskDetailsDataUpdated(true));
                    dispatch(setState({
                        key: "customerComplaintDataImageAndAudio",
                        value: _objectSpread(_objectSpread({}, customerComplaintDataImageAndAudio), {}, {
                            audio: null
                        })
                    }));
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    var handleClose = function () {
        setImageURL('');
        setISDrawerOpen(false);
    };
    var handleJobItemClick = function () {
        setisTranslateToJobChecked(function (prev) { return !prev; });
        jobItemClick();
    };
    var handleJobItemClickView = function () {
        jobItemClickViewJobs();
    };
    var onConfirmClick = function (audio) {
        setAudioUrl(audio.audioBlobUrl);
        dispatch(setState({
            key: "customerComplaintDataImageAndAudio",
            value: _objectSpread(_objectSpread({}, customerComplaintDataImageAndAudio), {}, {
                audioDuration: audioDuration,
                audio: {
                    audioBlobUrl: audio.audioBlobUrl,
                    audioFile: audio.audioFile
                }
            })
        }));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: "12px",
            padding: '2px'
        },
        width: "100%"
    }, /*#__PURE__*/ React.createElement(TextField, {
        disabled: isDisabled,
        id: "ComplaintDescription",
        placeholder: ComplaintInputPlaceHolder !== null && ComplaintInputPlaceHolder !== void 0 ? ComplaintInputPlaceHolder : 'Enter concerns...',
        value: (_customerComplaintDat2 = customerComplaintDataImageAndAudio === null || customerComplaintDataImageAndAudio === void 0 || (_customerComplaintDat3 = customerComplaintDataImageAndAudio.discription) === null || _customerComplaintDat3 === void 0 ? void 0 : _customerComplaintDat3.trimStart()) !== null && _customerComplaintDat2 !== void 0 ? _customerComplaintDat2 : "",
        multiline: true,
        rows: 4,
        variant: "outlined",
        fullWidth: true,
        onChange: handleTextField,
        sx: {
            "& fieldset": {
                border: 'none'
            }
        },
        inputProps: {
            maxLength: 1000
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        direction: 'column',
        paddingTop: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        gap: '16px',
        padding: 0
    }, isDisabled || !(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription) ? /*#__PURE__*/ React.createElement(IconButton, {
        id: "add-photo-icon",
        disabled: isDisabled
    }, /*#__PURE__*/ React.createElement(GallaryIconNewIcon, {
        height: 20,
        width: 20,
        sx: {
            stroke: systemColor.disabled
        }
    })) : /*#__PURE__*/ React.createElement(IconButton, {
        id: "add-photo-icon",
        disabled: isDisabled,
        onClick: onOpenClick
    }, /*#__PURE__*/ React.createElement(GallaryIconNewIcon, {
        height: 20,
        width: 20,
        sx: {
            stroke: systemColor.primary
        }
    })), isRecordAudio && /*#__PURE__*/ React.createElement(React.Fragment, null, !isPlaying && /*#__PURE__*/ React.createElement(React.Fragment, null, isDisabled || !(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription) || audioUrl !== "" && audioUrl !== null && audioUrl !== undefined ? /*#__PURE__*/ React.createElement(IconButton, {
        id: "startRecording",
        disabled: isDisabled || audioUrl !== "" && audioUrl !== null && audioUrl !== undefined
    }, /*#__PURE__*/ React.createElement(AudioButtonIcon, {
        height: 20,
        width: 20,
        sx: {
            stroke: systemColor.disabled
        }
    })) : /*#__PURE__*/ React.createElement(IconButton, {
        disabled: isDisabled || audioUrl !== "" && audioUrl !== null && audioUrl !== undefined,
        onClick: function () { return setAudioCaptureClick(function (pre) { return !pre; }); },
        id: "startRecording"
    }, /*#__PURE__*/ React.createElement(AudioButtonIcon, {
        height: 20,
        width: 20,
        sx: {
            stroke: systemColor.primary
        }
    })))), !isFromFinalInspection && customerVoiceSectionDetails && !((_getCustomerVoiceSect = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) !== null && _getCustomerVoiceSect !== void 0 && (_getCustomerVoiceSect = _getCustomerVoiceSect.OVERALL_COMMENTS_SECTION_ATTRIBUTES) !== null && _getCustomerVoiceSect !== void 0 && _getCustomerVoiceSect.HIDE) && /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%'
    }, isDisabled || !(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription) ? /*#__PURE__*/ React.createElement(IconButton, {
        disabled: isDisabled || !(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription)
    }, /*#__PURE__*/ React.createElement(MoreClickIconSVG, {
        sx: {
            color: systemColor.disabled
        },
        id: "settingIcon"
    })) : /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function () {
            setSaCommentClicked(function (prev) { return !prev; });
            // dispatch(resetState(["getStoredSAComment"]))
        }
    }, /*#__PURE__*/ React.createElement(MoreClickIconSVG, {
        sx: {
            color: systemColor.primary
        },
        id: "settingIcon"
    })))), !isFromFinalInspection && !((_getCustomerVoiceSect2 = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) !== null && _getCustomerVoiceSect2 !== void 0 && (_getCustomerVoiceSect2 = _getCustomerVoiceSect2.JOB_ITEMS_SECTION_ATTRIBUTES) !== null && _getCustomerVoiceSect2 !== void 0 && _getCustomerVoiceSect2.HIDE) && /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'start',
        alignItems: 'center',
        gap: '4px'
    }, isDisabled ? /*#__PURE__*/ React.createElement(MuiStack, {
        onClick: function () { return handleJobItemClickView(); }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        id: "translateToJobItem",
        sx: {
            color: systemColor.primary,
            cursor: 'pointer'
        }
    }, t("View jobs"), " ")) : /*#__PURE__*/ React.createElement(MuiStack, {
        onClick: function () { return handleJobItemClick(); },
        sx: {
            ":hover": {
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        id: "translateToJobItem",
        sx: {
            color: systemColor.primary
        }
    }, (_getCustomerVoiceSect3 = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) !== null && _getCustomerVoiceSect3 !== void 0 && (_getCustomerVoiceSect3 = _getCustomerVoiceSect3.JOB_ITEMS_SECTION_ATTRIBUTES) !== null && _getCustomerVoiceSect3 !== void 0 && _getCustomerVoiceSect3.MANDATORY ? t("TRANSLATE_TO_JOB_ITEM") + "*" : t("TRANSLATE_TO_JOB_ITEM"))), /*#__PURE__*/ React.createElement(Typography, {
        id: "translateToJobItemCount",
        style: {
            borderRadius: '20px',
            border: "1px solid ".concat(systemColor.primary),
            width: (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems) > 99 ? '33px' : '25px',
            height: '25px',
            backgroundColor: systemColor.lightThemeColor
        },
        align: "center",
        color: systemColor.primary
    }, getModuleHeaderCount !== null && getModuleHeaderCount !== void 0 && getModuleHeaderCount.jobItems ? getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems : 0, " "))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        paddingTop: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        alignItems: "center"
    }, audioUrl && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        style: {
            border: '1px solid #DEE4EB',
            backgroundColor: systemColor.backgroundColor,
            borderRadius: "8px",
            padding: '5px',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(AudioPlayer, {
        src: audioUrl,
        isSlider: true,
        audioDuration: audioDuration
    }), !isDisabled && /*#__PURE__*/ React.createElement("img", {
        src: DeleteButtonNewIcon,
        alt: "gallery-disable",
        style: {
            width: '36px',
            height: '36px',
            marginLeft: '10px'
        },
        onClick: onDeleteRecording
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        alignItems: "center",
        marginTop: 1.5
    }, complaintsPhotographList === null || complaintsPhotographList === void 0 ? void 0 : complaintsPhotographList.map(function (item, photoIndex) {
        console.log("itemuytrdes", item);
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            key: photoIndex,
            xs: 4,
            sm: 1.5,
            md: 2,
            lg: 1.5
        }, /*#__PURE__*/ React.createElement("div", {
            className: "1st",
            style: {
                position: 'relative',
                display: 'inline-block'
            }
        }, !isDisabled && /*#__PURE__*/ React.createElement(GridCloseIcon, {
            onClick: function () { return onClickRemovePhotoIcon(photoIndex, item.AttachmentId); },
            sx: {
                position: 'absolute',
                zIndex: 1,
                right: 4,
                top: 4,
                backgroundColor: "white",
                height: '15px',
                width: '15px',
                borderRadius: 50
            }
        }), /*#__PURE__*/ React.createElement("img", {
            src: item === null || item === void 0 ? void 0 : item.blobUrl,
            id: "downloadCustomerImg" + photoIndex,
            alt: "Image ".concat(photoIndex + 1),
            style: {
                width: '82px',
                height: '82px',
                borderRadius: '8px',
                position: 'relative'
            },
            onClick: function () { return handleClickImage(item === null || item === void 0 ? void 0 : item.blobUrl); }
        })));
    })))), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: imageURL
    }))), /*#__PURE__*/ React.createElement(ImageCaptureAndFileupload, {
        open: open,
        clearPopUpImages: clearPopUpImages,
        isImageEmpty: function (value) { return handleEmptyImage(value); },
        handleModelClose: function (value) { return handleCancleClick(value); },
        handleConfirm: function (data) { return handleConfirmClick(data); },
        downloadedImages: complaintsPhotographList,
        ParentId: listOfCustomerVoice && ((_listOfCustomerVoice$4 = listOfCustomerVoice[0]) === null || _listOfCustomerVoice$4 === void 0 ? void 0 : _listOfCustomerVoice$4.CustomerVoiceId),
        systemName: ESystemName.CustomerVoice,
        deleteUrl: deleteAllAttachmentUrl
    }), /*#__PURE__*/ React.createElement(AudioCapturePopUpComponent, {
        open: audioCaptureClick,
        handleModelClick: function (value) { return setAudioCaptureClick(value); },
        handleConfirmClick: function (audio) { return onConfirmClick(audio); }
    }), saCommentClicked && /*#__PURE__*/ React.createElement(TranslateToJobMessage, {
        isOpen: saCommentClicked,
        onClickMsgIcon: function () { return setSaCommentClicked(function (prev) { return !prev; }); },
        data: {
            imageList: []
        } // onClickMsgIcon={handleMessageIcon} 
        ,
        customerComplaintId: Module == isModuleConfig.Bajaj && listOfCustomerVoice ? (_listOfCustomerVoice$5 = listOfCustomerVoice[0]) === null || _listOfCustomerVoice$5 === void 0 ? void 0 : _listOfCustomerVoice$5.CustomerVoiceId : "" // data={jobItemData} 
        ,
        handleDataBack: function () { return console.log("I am bwhdhdhbdbd"); },
        setIsOpen: function () { return setSaCommentClicked(function (pre) { return !pre; }); },
        parentModuleDocumentId: parentModuleDocumentId !== null && parentModuleDocumentId !== void 0 ? parentModuleDocumentId : "",
        apiRequestParam: apiRequestParam,
        apiRequestPayload: apiRequestPayload,
        parentComponent: ESABoxParent.CustomerComplaint,
        isViewOnly: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
        isFromJobCard: apiRequestParam == APISchema.Jobcard,
        isEditable: Module == isModuleConfig.Bajaj ? false : true,
        createAndEditFlow: createAndEditFlow,
        IsFromParentAPt: IsFromParentAPt
    }));
};
